<template>
	<v-menu v-model="showMenu"
			:close-on-content-click="false"
			offset-y
			min-width="290px">
		<template #activator="{ on }">

        <v-text-field v-model="localeDate"
                      @blur="onBlur"
                      @keydown.enter="onLocaleDateChanged"
                      @keydown.tab="onTab"
                      @keydown="onKeyDown"
                      :label="label"
                      :rules="dateRules"
                      v-bind="$attrs"
                      v-on="on"
                      ref="textField" />
 
 		</template>
		<vops-date-picker v-model="isoDate"
						  @input="onIsoDateChanged"
						  :picker-date.sync="pickerDate"
						  :type="type"
						  no-title />
	</v-menu>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch, Emit, PropSync} from "vue-property-decorator";
import DateFormatter from "../services/dateFormatter";
import { VInput } from 'vuetify/lib';

@Component({
	inheritAttrs: false
})
export default class DateField extends Vue {
	@Prop({ type: String }) label: string;
	@Prop({ type: String }) value: string;
	@Prop({ type: Boolean, default: false }) month: boolean;
	@Prop({ type: Array }) rules: [];
	@Prop({type: String}) defaultDate: string;
  @Prop({type: Boolean, default: false}) preventSubmit: boolean;

	monthformatter: string = "MMMM YYYY";
	showMenu: boolean = false;
	localeDate: string = null;
	isoDate: string = null;
	isValidIso: boolean = true;
	pickerDate: string = null;

	created() {
  	this.updateIsoDate(this.value);
		this.updateLocaleDate(this.value);
	}
  
	get type() {
		return this.month ? 'month' : 'date';
	}

	get dateRules() {
		return [this.validDate].concat(this.rules || []);
	}

	get validDate() {
    if (this.localeDate == null || this.localeDate === '')
			return true;
		return this.isValidIso || this.$vopsui.labels.invalidDate();
	}

	@Emit()
	private input(value: string) {
	}

	@Watch("month")
	private onTypeChange() {
    this.updateLocaleDate(this.isoDate);
		this.updateIsoDate(this.localeDate);
		this.input(this.isoDate);
	}

	@Watch("value")
	private onValueChange(isoValue: string) {
    if (this.updateIsoDate(isoValue)) {
			this.input(this.isoDate);
			this.updateLocaleDate(isoValue);
		}
	}

	@Watch("defaultDate", {immediate: true})
	onDefaultDateChanged() {
    this.pickerDate = this.defaultDate;
	}

	onBlur(event) {
    this.onLocaleDateChanged(event);
	}

	onTab() {
    this.showMenu = false;
	}

	private updateIsoDate(localeDate: string): boolean {
    const formatter = (this.type === "month") ? this.monthformatter : undefined;
		let isoDate = DateFormatter.toIsoString(localeDate, formatter);

		if (isoDate == null && localeDate != null) {
			isoDate = localeDate;
			this.isValidIso = false;
		} else {
			this.isValidIso = true;
		}

		const changed = isoDate !== this.isoDate;
		this.isoDate = isoDate;
		return changed;
	}

	private updateLocaleDate(isoDate: string): boolean {
    if (!this.isValidIso)
			return false;

		const formatter = (this.type === "month") ? this.monthformatter : undefined;
		const localeDate = DateFormatter.toLocaleString(isoDate, formatter);
		const changed = localeDate !== this.localeDate;
		this.localeDate = localeDate;
		return changed;
	}

	onLocaleDateChanged(event:any) {
    if (this.updateIsoDate(this.localeDate)) {
  		this.input(this.isoDate);
			this.updateLocaleDate(this.isoDate);
		}
   
    if (!this.isValidIso || (this.preventSubmit && event.type === 'keydown' && event.keyCode === 13))
      event.preventDefault();
  }

	onIsoDateChanged() {
    this.showMenu = false;
		this.isValidIso = true;
		if (this.updateLocaleDate(this.isoDate))
			this.input(this.isoDate);
	}

	onKeyDown() {
    this.isValidIso = true;
	}

  
	validate(force: boolean = false) {
    const textField = this.$refs.textField as any;
		return textField.validate(force);
	}
}
</script>